import { Info } from 'lucide-react'
import { ReactNode } from 'react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

interface InfoTooltipProps {
  content: ReactNode
  ariaLabel?: string
  className?: string
}

export const InfoTooltip = ({ content, ariaLabel = 'Info', className = '' }: InfoTooltipProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={ariaLabel}
          className={`inline-flex h-4 w-4 items-center justify-center text-[rgba(45,41,35,0.48)] hover:text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.48)] dark:hover:text-[rgba(253,253,253,0.72)] transition-colors ${className}`}
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="start"
        className="w-[260px] border-[rgba(45,41,35,0.12)] dark:border-[rgba(253,253,253,0.12)] bg-white/95 dark:bg-[#0a0a0a] text-[#2d2923] dark:text-[#fdfdfd] px-3 py-2 text-xs leading-[16px]"
      >
        {content}
      </PopoverContent>
    </Popover>
  )
}

